import React, { useContext } from 'react';
// import use params
import { useParams } from 'react-router-dom';
// import cart context 
import { CartContext } from '../contexts/CartContext';
import { ProductContext } from '../contexts/ProductContext';
import { Link } from 'react-router-dom';
const ProductDetails = () => {
  // get the product id from the url 
  const {id} = useParams()
  const {products} = useContext(ProductContext);
  const {addToCart} = useContext(CartContext);

  // get the single product based on the id
  const product = products.find(item=>
    {
      return item.id === parseInt(id);
    })

    if (!product) {
      return (
        <section className='h-screen flex items-center justify-center'>
          Loading...
        </section>
      )
    }

    console.log(product);
    // destructure product
    const {title,price,description,image} = product;
  return <div className='pt-32 pb-12 lg:py-32 h-screen flex items-center'>
    <div className="container mx-auto">
      {/* image and text container */}
      <div className='flex flex-col lg:flex-row items-center gap-7'>
         {/* image */}
      <div>
       <img src={image} alt="" className='max-w-[200px] lg:max-w-sm ' />
      </div>
      {/* text */}
      <div className='flex flex-col items-center gap-3'>
        <h1 className='text-lg font-medium '>{title}</h1>
        <span className='text-lg font-semibold text-red-500'>Price: ${price}</span>
        <p className='text-[14px] text-center '>{description}</p>
        {/* buttons */}
        <div className='flex gap-4'>
           <button type="button"
        className='px-5 py-2 rounded-lg bg-black text-white shadow-lg'
        onClick={()=>addToCart(product,product.id)}
        >Add To Cart</button>
        <Link to='/'>
        <button  className='px-5 py-2 rounded-lg bg-black text-white shadow-lg' >
          Back to shopping
        </button>
        </Link>
        
        </div>
       
      </div>
      </div>
     
    </div>
  </div>;
};
 
export default ProductDetails;
